import { render, staticRenderFns } from "./InternalDetails.vue?vue&type=template&id=26366f30&scoped=true"
import script from "./InternalDetails.vue?vue&type=script&lang=js"
export * from "./InternalDetails.vue?vue&type=script&lang=js"
import style0 from "./InternalDetails.vue?vue&type=style&index=0&id=26366f30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26366f30",
  null
  
)

export default component.exports